import React, { useState, useEffect } from "react";
import logger from "../utils/logger.ts";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import * as icon from "../services/icon";
import { WALLET, ERROR_404 } from "src/constants/routes";
import { connectResponse } from "utils/connectResponse";
import * as api from "api/api";
import { getbOMMreward500kpool } from "api/api";
import {
  fetchWalletSuccess,
  fetch_gg_reward_by_user,
  set_claim_timer,
} from "../redux/actions/wallet";
import ConnectWalletModal from "components/Modals/ConnectWalletModal";
import SEO from "components/SEO";
import InvalidGangstaModal from "components/Modals/InvalidGangstaModal";
import WalletLogin from "components/WalletLogin/WalletLogin";
import WalletCustomerDetail from "components/WalletCustomerDetail/WalletCustomerDetail";
import axios from "axios";
import { getMetadataForId } from "../services/meta";
import CheckUnSyncWalletModal from "components/Modals/CheckUnSyncWalletModal";
import ConnectionOptionModal from "components/Modals/ConnectionOptionModal";
import MultiClaimModal from "components/Modals/MultiClaimModal";

import { WALLET_TYPE } from "src/constants/walletType";
import MultiClaimModalLoader from "components/Modals/MultiClaimModalLoader";
import GGRewardDisplayModal from "components/Modals/ggRewardDisplay";

const dayInMilliseconds = 24 * 60 * 60 * 1000; //milliSeconds

const Wallet = () => {
  const [ownedGangsters, setOwnedGangsters] = useState([]);
  const [unSyncedNfts, setUnSyncedNfts] = useState([]);

  const [gbetData, setgbetData] = useState([]);
  const [totalNftOwned, setTotalNftOwned] = useState(0);

  const [connectLoading, setConnectLoading] = useState(false);
  const [connectSuccess, setConnectSuccess] = useState({ status: "loading" });
  const [accumulatedGbet, setAccumulatedGbet] = useState(0);
  const [accumulatedbOMM500kpool, setAccumulatedbOMM500kpool] = useState(0);
  const [gbetInWallet, setGbetInWallet] = useState(0);
  const [isLoading, setIsLoading] = useState(null);
  const address = useSelector((state) => state.wallet.walletAddress);
  const [invalidAddress, setInvalidAddress] = useState(false);
  const [unSyncModal, setUnSyncModal] = useState(false);
  const [walletConnection, setWalletConnection] = useState(false);
  const [ownerAccount, setOwnerAccount] = useState(false);
  const [goldenKeyCount, setGoldenKeyCount] = useState(null);
  const {
    walletType,
    walletPath,
    transport,
    userGGReward,
    claimTimer,
    claimTimerLoading,
  } = useSelector((state) => state.wallet);

  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const iconPrintApis = async () => {
    await icon.printApis();
  };

  useEffect(() => {
    window.addEventListener("ICONEX_RELAY_RESPONSE", eventHandler, false);

    iconPrintApis();
    return () => {
      window.removeEventListener("ICONEX_RELAY_RESPONSE", eventHandler);
    };
  }, []);

  useEffect(() => {
    getbOMMreward500kpool(id).then((res) =>
      setAccumulatedbOMM500kpool(res.data.reward)
    );
  }, []);

  useEffect(() => {
    //auto sync after 5 seconds

    let timeout;

    timeout = setTimeout(async () => {
      let promises = [];

      if (unSyncedNfts.length > 0) {
        unSyncedNfts.forEach((id) => {
          promises.push(api.syncToken(id));
        });
        await Promise.all(promises);
        setUnSyncedNfts([]);
      }
    }, 5000);

    return () => {
      clearTimeout(timeout);
    };
  }, [unSyncedNfts]);

  useEffect(() => {
    if (!address && id == "connect") return;
    getGbetinWallet(id);
    goldenKeyinWallet(id);
    getGangsterAndCalculateGbet(id);
    logger.debug("Wallet initialization", { address, id });
    if (id == address) {
      setOwnerAccount(true);
      dispatch(fetch_gg_reward_by_user(address));
    } else {
      setOwnerAccount(false);
      if (icon.isValidAddress(id)) {
        dispatch(fetch_gg_reward_by_user(id));
      } else {
        navigate(ERROR_404.INDEX);
      }
    }
    logger.debug("User GG reward initialized", { userGGReward });
  }, []);

  useEffect(() => {
    if (id == address) {
      setOwnerAccount(true);
      dispatch(fetch_gg_reward_by_user(address));
    } else {
      setOwnerAccount(false);
      dispatch(fetch_gg_reward_by_user(id));
    }
    goldenKeyinWallet(id);
    logger.debug("User GG reward updated for ID", { userGGReward, id });
  }, [id]);

  useEffect(() => {
    if (address && walletType == WALLET_TYPE.LEDGER && id == "connect") {
      getGbetinWallet(address);
      dispatch(fetch_gg_reward_by_user(address));
      getGangsterAndCalculateGbet(address);
      navigate(WALLET.addSlug(WALLET.INDEX, address));
    }
    logger.debug("User GG reward updated for address", { userGGReward, address });
  }, [address]);

  const getGbetinWallet = async (address) => {
    await setGbetInWallet(0);
    const balance = await icon.getGbetBalanceInWallet(address);

    setGbetInWallet(balance);
  };

  const goldenKeyinWallet = async (address) => {
    const balance = await icon.getGoldenKeyCount(address);
    setGoldenKeyCount(balance);
  };

  const [MultiClaimLoader, setMultiClaimLoader] = useState(false);
  const handleMultiClaimLoader = (status) => {
    setMultiClaimLoader(false);
    setMultiClaimState({ status: "loading" });
    getGbetinWallet(address);
    getGangsterAndCalculateGbet(address);

    // console.log(status);
    // if (status == "buy") {
    //   fetchNftDetails();
    //   getSalePrice();
    // }
  };

  const eventHandler = async (event) => {
    const response = await connectResponse(event);

    const success = { status: "success" };
    const cancel = { status: "cancel" };
    const error = { status: "error" };
    if (response.type == "address") {
      dispatch(fetchWalletSuccess(response.data));
      setConnectSuccess(success);
      getGbetinWallet(response.data);
      // getGangsterAndCalculateGbet(response.data);
    } else if (response.type == "json-RPC") {
      setTimeout(() => {
        getTx(response.data.result);
      }, 4000);
    } else if (response.type == "cancel") {
      setTotalClaimingGbet(0);
      setMultiClaimState(cancel);
      setConnectSuccess(error);
    } else {
      setConnectSuccess(error);
      setTotalClaimingGbet(0);
      setMultiClaimState(error);
    }
  };

  const getTx = async (tx) => {
    const res = await icon.getTransactionResult(tx);
    logger.debug("Transaction result", { tx, result: res });
    if (res.status === "pending") {
      getTxResultWithTimer(tx);
    } else if (res.status === "success") {
      setTimeout(() => {
        setMultiClaimModal(false);
        setMultiClaimState({ status: "success" });
        setTotalClaimingGbet(0);
        setAutoSelectState(false);
      }, 2000);

      setConnectLoading(false);
      setSelected_NFT([]);
    } else if (res.status === "error") {
      setTotalClaimingGbet(0);
      setMultiClaimState({ status: "error" });
    } else {
      setTotalClaimingGbet(0);
      setMultiClaimState({ status: "error" });
    }
  };

  const handleLogin = async () => {
    setConnectSuccess({ status: "loading" });
    setConnectLoading(true);
    icon.handleLogin();
  };

  const getTxResultWithTimer = (txHash) => {
    setTimeout(() => {
      getTx(txHash);
    }, 4000);
  };

  const [multiClaimState, setMultiClaimState] = useState({
    status: "loading",
  });

  const _handleMultiClaimGbet = async (nft_list) => {
    setMultiClaimState({ status: "loading" });
    setMultiClaimLoader(true);
    const res = await icon.claim_multiple_gbet(
      {
        address,
        nft_list,
      },
      walletType,
      walletPath,
      transport
    );
    if (walletType == WALLET_TYPE.LEDGER) {
      if (res?.name == "TransportStatusError") {
        setMultiClaimState({ status: "cancel" });
      } else if (res) {
        getTxResultWithTimer(res);
      } else {
        setMultiClaimState({ status: "error" });
      }
    }
  };

  const msToTime = (distance) => {
    var _second = 1000;
    var _minute = _second * 60;
    var _hour = _minute * 60;
    var _day = _hour * 24;

    if (distance < 0) {
      return;
    }
    var days = Math.floor(distance / _day);
    var hours = Math.floor((distance % _day) / _hour) + days * 24;
    var minutes = Math.floor((distance % _hour) / _minute);
    var seconds = Math.floor((distance % _minute) / _second);
    return `${hours < 10 ? `0${hours}` : hours}:${
      minutes < 10 ? `0${minutes}` : minutes
    }`;
  };

  const [startInterval, setstartInterval] = useState(false);
  const [lastClaimTimer, setLastClaimTimer] = useState({});
  const [lazyLoadingGansta, setLazyLoadingGanstaStatus] = useState(true);

  const getGangsters = (nftOwned, promises) => {
    setFilteredCollected([]);
    setgbetData([]);
    setMaxItem(0);
    Promise.all(promises)
      .then(async (nftData) => {
        let unSynced = [];
        let last_claim_timer = {};
        for (let i = 0; i < nftData.length; i++) {
          try {
            logger.debug("Processing NFT data", { total: nftData.length, current: i });
            if (!nftData[i].msg) {
              const META_JSON = await getMetadataForId(
                parseInt(nftData[i]?.metaId)
              );
              const base_url =
                import.meta.env.VITE_CLOUDFRONT_PREFIX +
                "/meta/" +
                META_JSON.ipfs.split("/")[1];
              const metadataResponse = await axios.get(base_url);
              const balance = await icon.getGbetBalance(nftOwned.nftList[i]);
              const salePrice = await icon.getSalePrice(nftOwned.nftList[i]);

              logger.debug("NFT balance retrieved", { nftId: nftOwned.nftList[i], balance });
              // const { image_url } = metadataResponse.data;
              const { image } = metadataResponse.data;
              const image_url =
                import.meta.env.VITE_CLOUDFRONT_PREFIX +
                "/img/" +
                image.split("/")[1];
              // console.log("IMAGEEEE", image_url);
              let skillData = {
                skill: {},
                stat: 0,
              };
              Object.keys(nftData[i].skills).map((data) => {
                skillData.skill[nftData[i].skills[data][0]] = parseInt(
                  nftData[i].skills[data][1]
                );
                skillData.stat += parseInt(nftData[i].skills[data][1]);
              });
              let _nftDetails = {
                image: image_url,
                number: null,
                accumulatedGbet: balance,
                salePrice: salePrice,
                isGangster: nftData[i].isGangster,
                total_stats: skillData.stat,
                class_type: nftData[i].className,
                token: `0x${parseInt(nftOwned.nftList[i]).toString(16)}`,
                token_name: nftData[i].characterName,
                skills: skillData.skill,
                id: nftOwned.nftList[i],
              };
              logger.debug("NFT details created", { nftDetails: _nftDetails });
              // dispatch(set_claim_timer(last_claim_timer));
              if (i >= nftData.length - 1) {
                setLazyLoadingGanstaStatus(false);
                setstartInterval(true);
              } else {
                setstartInterval(false);
                setLazyLoadingGanstaStatus(true);
              }
              setgbetData((prev) => {
                return [
                  ...prev,
                  {
                    id: nftOwned.nftList[i],
                    token_uri: image_url,
                    _nftData: _nftDetails,
                  },
                ];
              });
            } else {
              if (nftData[i].msg === "Generating NFT") {
                unSynced.push(nftOwned.nftList[i]);
                setUnSyncedNfts(unSynced);
              }
            }
          } catch (e) {
            logger.componentError('Wallet', e, { nftId: nftOwned.nftList[i] });
            // window.location.reload();
          }
        }

        setOwnedGangsters(nftOwned);
      })
      .catch((err) => {
        logger.componentError('Wallet', err, { operation: 'getGangsters' });
      });
  };

  const getGangsterAndCalculateGbet = async (address) => {
    setgbetData([]);
    setIsLoading(true);
    setAccumulatedGbet(0);
    const nftOwned = await icon._getOwnedNft(address, `0x1`);

    setTotalNftOwned(nftOwned.nftOwned);

    const totalPages = parseInt(nftOwned.totalPage);
    for (let i = 1; i <= totalPages; i++) {
      const currentHex = i.toString(16);
      let promises = [];
      let promise = [];
      let accumulatedGbetPromises = [];

      const individualPageNftOwned = await icon._getOwnedNft(
        address,
        `0x${currentHex}`
      );

      if (individualPageNftOwned == "Invalid Address") {
        return setInvalidAddress(true);
      }

      console.log(
        "individualPageNftOwned.nftList.length",
        individualPageNftOwned
      );

      if (individualPageNftOwned.nftList.length) {
        const promise = [];

        individualPageNftOwned?.nftList?.forEach(async (nft, index) => {
          if (index == 0 && i == 1) {
            promise.push(icon.getCharacterInfo(nft));
          } else {
            promise.push(icon.getCharacterInfo(nft));
          }

          accumulatedGbetPromises.push(icon.getGbetBalance(nft));
        });

        getGangsters(individualPageNftOwned, promise);
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
        getGangsters(individualPageNftOwned, promises);
      } else {
        setTimeout(() => {
          setIsLoading(false);
          setLazyLoadingGanstaStatus(false);
        }, 3000);
      }
      if (accumulatedGbetPromises.length) {
        Promise.all(accumulatedGbetPromises)
          .then((i) => {
            i.forEach((price) => {
              setAccumulatedGbet((prev) => {
                return prev + Number(price);
              });
            });
          })
          .catch((err) => {
            logger.componentError('Wallet', err, { operation: 'getGangsterAndCalculateGbet' });
          });
      } else {
        setAccumulatedGbet(0);
      }
    }
  };

  const handleClose = () => {
    setConnectLoading(false);
    if (id == "connect") {
      navigate(WALLET.addSlug(WALLET.INDEX, address));

      getGbetinWallet(address);

      getGangsterAndCalculateGbet(address);
    }
    setConnectSuccess({ status: "loading" });
  };

  useEffect(() => {
    if (unSyncedNfts.length && !connectLoading) {
      setUnSyncModal(true);
    }
  }, [unSyncedNfts]);

  // useEffect(() => {
  //   goldenKeyinWallet(id);
  // }, []);

  const [selected_NFT, setSelected_NFT] = useState([]);
  const [maxItem, setMaxItem] = useState(0);
  const [multiClaimModal, setMultiClaimModal] = useState(false);
  const [autoSelectState, setAutoSelectState] = useState(false);

  const [ItemRemaining, setItemRemaining] = useState(0);
  const [TotalClaimingGbet, setTotalClaimingGbet] = useState(0);

  const [filteredCollected, setFilteredCollected] = useState([]);

  const autoSelect = async () => {
    if (!autoSelectState) {
      await setSelected_NFT([]);
      let f = filteredCollected;
      await f.sort(function (a, b) {
        return b._nftData.accumulatedGbet - a._nftData.accumulatedGbet;
      });
      let l = [];
      let t = 0;
      await setFilteredCollected(f);
      await f.slice(0, maxItem).map((data) => {
        l.push(data._nftData.id);
        t += data?._nftData.accumulatedGbet;
      });
      await setTotalClaimingGbet(t);
      logger.debug("Auto-selected NFTs", { selectedNFTs: l });
      await setSelected_NFT(l);
      await setItemRemaining(0);
      setAutoSelectState(true);
    } else {
      await setTotalClaimingGbet(0);
      await setAutoSelectState(false);
      await setSelected_NFT([]);
      await setItemRemaining(maxItem);
    }
    logger.debug("Selected NFTs updated", { selectedNFTs: selected_NFT });
  };
  useEffect(() => {
    let isMounted = true;
    
    const processGbetData = async () => {
      try {
        // console.log("setting up");
        // console.log(gbetData);
        let hadGbetList = [];
        // setgbetData([]);

        await gbetData.map((data, index) => {
          if (data?._nftData.accumulatedGbet >= 1) {
            hadGbetList.push(data);
          }
        });
        if (isMounted) {
          await setFilteredCollected(hadGbetList);
        }
        const limit = await icon.get_batch_claim_limit();
        const size = hadGbetList.length;
        if (limit >= size && isMounted) {
          await setMaxItem(size);
          await setItemRemaining(size);
        }
      } catch (error) {
        console.error('Error processing gbet data:', error);
      }
    };

    processGbetData();

    return () => {
      isMounted = false;
    };
  }, [gbetData]);
  useEffect(() => {
    let isMounted = true;
    
    const fetchBatchClaimLimit = async () => {
      try {
        const limit = await icon.get_batch_claim_limit();
        logger.debug("Batch claim limit fetched", { limit: parseInt(limit), rawLimit: limit });
        if (isMounted) {
          await setMaxItem(parseInt(limit));
        }
      } catch (error) {
        console.error('Error fetching batch claim limit:', error);
      }
    };

    fetchBatchClaimLimit();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    logger.debug("Loading state changed", { isLoading });
  }, [isLoading]);

  const pageMetaData = {
    pageTitle: `Wallet | GangstaBet: A Digital Collectible`,
    pageDescription: null,
    pageKeywords: null,
    pageImage: null,
  };

  const [GGRewardDisplayShow, setGGRewardDisplayShow] = useState(false);
  return (
    <SEO pageMetaData={pageMetaData}>
      <div className="container">
        <div className="wallet">
          {id != "connect" ? (
            <div>
              <WalletCustomerDetail
                totalOwned={totalNftOwned}
                address={address}
                setGGRewardDisplayShow={setGGRewardDisplayShow}
                gangstaCollection={gbetData}
                // lastClaimTimer={claimTimer}
                multiClaimModal={multiClaimModal}
                userGGReward={userGGReward}
                ownerAccount={ownerAccount}
                ownedGangsters={ownedGangsters}
                setMultiClaimModal={setMultiClaimModal}
                lazyLoadingGansta={lazyLoadingGansta}
                accumulatedGbet={accumulatedGbet}
                gbetInWallet={gbetInWallet}
                goldenKeyCount={goldenKeyCount}
                bOMMreward500kPool={accumulatedbOMM500kpool}
                isLoading={isLoading}
                id={id}
              />
            </div>
          ) : (
            <WalletLogin onClick={() => setWalletConnection(true)} />
          )}
        </div>
        <ConnectWalletModal
          isVisible={connectLoading}
          response={connectSuccess}
          onClick={handleClose}
        />
        <InvalidGangstaModal isVisible={invalidAddress} isWallet />
        <CheckUnSyncWalletModal
          isVisible={unSyncModal}
          onClick={() => setUnSyncModal(false)}
        />
        <ConnectionOptionModal
          isVisible={walletConnection}
          onClose={() => {
            setWalletConnection(false);
          }}
          iconexConnection={handleLogin}
        />{" "}
        <MultiClaimModal
          gangstaCollection={gbetData}
          _handleMultiClaimGbet={_handleMultiClaimGbet}
          isVisible={multiClaimModal}
          onClose={() => {
            setTotalClaimingGbet(0);

            setMultiClaimModal(false);
            setSelected_NFT([]);
            setAutoSelectState(false);
          }}
          selected_NFT={selected_NFT}
          lazyLoadingGansta={lazyLoadingGansta}
          setSelected_NFT={setSelected_NFT}
          maxItem={maxItem}
          setAutoSelectState={setAutoSelectState}
          setMaxItem={setMaxItem}
          TotalClaimingGbet={TotalClaimingGbet}
          setTotalClaimingGbet={setTotalClaimingGbet}
          setItemRemaining={setItemRemaining}
          autoSelectState={autoSelectState}
          ItemRemaining={ItemRemaining}
          filteredCollected={filteredCollected}
          setFilteredCollected={setFilteredCollected}
          autoSelect={autoSelect}
        />
        <MultiClaimModalLoader
          isVisible={MultiClaimLoader}
          response={multiClaimState}
          onClick={handleMultiClaimLoader}
          totalGbet={TotalClaimingGbet}
        />
        <GGRewardDisplayModal
          isVisible={GGRewardDisplayShow}
          userGGReward={userGGReward}
          bOMMreward500kPool={accumulatedbOMM500kpool}
          onClose={() => {
            setGGRewardDisplayShow(false);
          }}
        />
      </div>
    </SEO>
  );
};

export default Wallet;
